/** Role identifiers shared with the backend (analytics-api). */
export const ROLE_ADMIN = 'admin'
/** Bruktbil: two independent roles (#673). Basic opens the page with market
 *  aggregates; advanced adds the dealer-level views. No admin bypass for
 *  either — admins are granted both roles. */
export const ROLE_USEDCAR = 'usedcartransfer_basic'
export const ROLE_USEDCAR_ADVANCED = 'usedcartransfer_advanced'
export const ROLE_BRUKTBILFINANS = 'bruktbilfinans_selectedbank_user'
export const ROLE_LEADS = 'leads_advanced_user'
/** Export anywhere in Leads = a subscribing customer (#869). Granted on top of
 *  ROLE_LEADS and opens nothing on its own. A demo user is a Leads user
 *  without it. */
export const ROLE_LEADS_TABLE_EXPORTER = 'leads_table_exporter'
/** Oppslag: one page, two roles. Basic opens the page and the API-key
 *  technical lookup (no personal data); premium unlocks the Maskinporten
 *  owner-identity tabs *within* the page. Premium alone is a pure API
 *  entitlement (owner lookups used elsewhere in the solution) and does NOT
 *  open the page — the backend guard agrees. */
export const ROLE_OPPSLAG_BASIC = 'oppslag_basic_user'
export const ROLE_OPPSLAG_PREMIUM = 'oppslag_premium_user'

export interface RoleBearer {
  roles?: string[]
}

/**
 * True when the user holds at least one of `roles`. `admin` passes unless
 * `adminBypass` is false (Bruktbil has no admin bypass, #673).
 */
export function hasAnyRole(
  user: RoleBearer | null | undefined,
  roles: string[],
  adminBypass = true,
): boolean {
  const userRoles = user?.roles ?? []
  if (adminBypass && userRoles.includes(ROLE_ADMIN)) return true
  return roles.some((r) => userRoles.includes(r))
}
